import React from "react";

/** Mutable bag filled during SSR when a `<Redirect>` renders, same role as v5 `StaticRouter` context. */
export interface SsrRouterContextValue {
	url?: string;
	statusCode: number;
}

export const SsrRouterContext = React.createContext<SsrRouterContextValue | null>(null);
